
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/[settingsPage]",
      function () {
        return require("private-next-pages/user/[settingsPage].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/[settingsPage]"])
      });
    }
  